import { Component, OnInit } from '@angular/core';
import { User, UserService } from '@inera/common';

@Component({
  standalone: false,
  selector: 'navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  public user: User;

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.userService.getUser().subscribe(it => {
      this.user = it;
    });
  }

  public getUserDescription(): string {
    let description = '';

    if (this.user?.employeeHsaId) {
      description += '(' + this.user.employeeHsaId + ')';
    }

    if (this.user?.commissionName) {
      description += ', ' + this.user.commissionName;
    }

    if (this.user?.healthCareProviderHsaId) {
      description += ' för ' + this.user.healthCareProviderHsaId;
    }

    return description;
  }
}
